import { render } from "./MarketPlaceLoginPage.vue?vue&type=template&id=8c028ab6"
import script from "./MarketPlaceLoginPage.vue?vue&type=script&lang=js"
export * from "./MarketPlaceLoginPage.vue?vue&type=script&lang=js"

import "./MarketPlaceLoginPage.vue?vue&type=style&index=0&id=8c028ab6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__